import React, { useEffect, useRef, useState } from "react";
import {
  ChangeTitle,
  encryptUrlData,
  toAbsoluteUrl,
} from "../../helpers/Reusable";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { BiMinus } from "react-icons/bi";
import { BsPlusLg } from "react-icons/bs";
import { FaAngleRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { LiaBookSolid } from "react-icons/lia";
import DOMPurify from "dompurify";

const PracticeArticle = () => {
  ChangeTitle("Practice Articles");
  const [mainMenu, setMainMenu] = useState("");
  const [openIndex, setOpenIndex] = useState(null);
  const [childOpenIndex, setChildOpenIndex] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [practiceList, setPracticeList] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const totalPages = Math.ceil(totalItems / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  const isOpen = (index) => openIndex === index;
  const isChildOpen = (parentIndex, childIndex) =>
    childOpenIndex[parentIndex] === childIndex;

  // Toggle parent accordion
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    setChildOpenIndex((prev) => ({ ...prev, [index]: null })); // Close child when parent closes
  };

  // Toggle child accordion
  const toggleChildAccordion = (parentIndex, childIndex) => {
    setChildOpenIndex((prev) => ({
      ...prev,
      [parentIndex]: prev[parentIndex] === childIndex ? null : childIndex,
    }));
  };

  // Category List API Call
  const viewCategoryList = async () => {
    const param = {};
    var response = await postData(
      "practisecategory/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data?.map((item) => ({
        id: item._id,
        name: item.name,
      }));
      setCategoryList(listData);
      setMainMenu(listData[0]?.id);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Practice List API Call
  const viewPracticeList = async (practisecategoryId, limit, offset) => {
    const param = {
      offset: offset,
      limit: limit,
      term: "",
      sort: "",
      sortBy: "",
      practisecategoryId: practisecategoryId,
    };
    var response = await postData(
      "practise/user/list",
      param,
      apiHeader(false)
    );

    console.log("response", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.data;
      setPracticeList(data);
      setTotalItems(+response.data.data.total);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewCategoryList();
  }, []);

  useEffect(() => {
    viewPracticeList(mainMenu, limit, offset);
  }, [mainMenu, limit, offset]);

  useEffect(() => {
    setOffset(0);
  }, [mainMenu]);

  const printRef = useRef();

  const [isShowInIframe, setIsShowInIframe] = useState(true);

  const handlePrint = (ref, fileName = "Print") => {
    if (!ref.current) return;

    const printContents = ref.current.cloneNode(true); // Clone content
    const printIframe = document.createElement("iframe");

    // Hide the iframe
    printIframe.style.position = "absolute";
    printIframe.style.width = "0";
    printIframe.style.height = "0";
    printIframe.style.border = "none";

    document.body.appendChild(printIframe);

    const originalTitle = document.title;
    document.title = fileName;

    printIframe.contentDocument.open();
    printIframe.contentDocument.write(`
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            @page { margin: 0; }
          </style>
        </head>
        <body>
          <div id="print-content" class="print-container"></div>
        </body>
      </html>
    `);
    printIframe.contentDocument.close();

    const appendContentAndPrint = () => {
      const printContentDiv =
        printIframe.contentDocument.getElementById("print-content");
      if (!printContentDiv) {
        document.body.removeChild(printIframe);
        document.title = originalTitle;
        return;
      }

      printContentDiv.appendChild(printContents);

      printIframe.contentWindow.focus();
      printIframe.contentWindow.print();

      printIframe.contentWindow.onafterprint = () => {
        document.body.removeChild(printIframe);
        document.title = originalTitle;
        setIsShowInIframe(true);
      };

      // Fallback cleanup
      setTimeout(() => {
        if (printIframe.parentNode) {
          document.body.removeChild(printIframe);
          document.title = originalTitle;
          setIsShowInIframe(true);
        }
      }, 5000);
    };

    if (printIframe.contentDocument.readyState === "complete") {
      appendContentAndPrint();
    } else {
      printIframe.contentWindow.onload = appendContentAndPrint;
    }
  };

  return (
    <>
      <div className="w-full p-[5%] bg-yellow min-h-screen">
        <div className="xxl:container mx-auto">
          <div className="relative z-[5] mb-[3rem] lg:w-[90%] xl:w-[70%] overflow-x-auto flex justify-evenly p-[1rem] md:p-[2rem] mx-auto practice-main-menu">
            {categoryList.map((data) => (
              <button
                className={
                  mainMenu == data.id
                    ? "practice-box-menu-active practice-box-menu"
                    : "practice-box-menu"
                }
                onClick={() => setMainMenu(data.id)}
              >
                {data.name}
              </button>
            ))}
          </div>
          <div className="w-full practice-articles">
            {practiceList?.length > 0 && (
              <div className="w-full md:w-[90%] mx-auto flex flex-col gap-5 mb-[5%]">
                {practiceList?.map((chapter, chapterIndex) => {
                  const globalChapterIndex = offset + chapterIndex; // ✅ include offset here
                  const hasCategory = !!chapter?.chapterName?.trim();
                  const hasArticles =
                    Array.isArray(chapter?.articlesDetail) &&
                    chapter.articlesDetail.length > 0;

                  return (
                    <div key={globalChapterIndex}>
                      {/* 🟢 CASE 1: categoryName exists */}
                      {hasCategory ? (
                        <div>
                          <button
                            onClick={() => toggleAccordion(globalChapterIndex)}
                            className={`p-[1.5rem] lg:p-[2rem] flex w-full text-start gap-5 ${
                              globalChapterIndex % 2 === 0
                                ? "practice-articles-box"
                                : "practice-articles-box practice-articles-box-y"
                            }`}
                          >
                            <LiaBookSolid className="mt-2 practice-articles-box-book-icon" />
                            <span>{chapter?.chapterName}</span>
                          </button>

                          {isOpen(globalChapterIndex) && hasArticles && (
                            <div className="p-[1.5rem] lg:p-[2rem] practice-articles-box-active">
                              {chapter.articlesDetail.map(
                                (article, articleIndex) => {
                                  const hasArticle =
                                    !!article?.articleName?.trim();
                                  const hasTopics =
                                    Array.isArray(article?.topicDetail) &&
                                    article.topicDetail.length > 0;

                                  return (
                                    <div
                                      key={articleIndex}
                                      className="pb-[1.5rem]"
                                    >
                                      {/* 🔵 CASE 3: articleName exists */}
                                      {hasArticle ? (
                                        <>
                                          <button
                                            onClick={() =>
                                              toggleChildAccordion(
                                                globalChapterIndex,
                                                articleIndex
                                              )
                                            }
                                            className="p-[1.5rem] lg:p-[2rem] flex w-full text-start justify-between practice-articles-box2"
                                          >
                                            <span>{article?.articleName}</span>
                                            {isChildOpen(
                                              globalChapterIndex,
                                              articleIndex
                                            ) ? (
                                              <BiMinus className="practice-articles-plus" />
                                            ) : (
                                              <BsPlusLg className="practice-articles-plus" />
                                            )}
                                          </button>

                                          {isChildOpen(
                                            globalChapterIndex,
                                            articleIndex
                                          ) &&
                                            hasTopics && (
                                              <div className="p-[1.5rem] lg:p-[2rem] practice-articles-box2-active">
                                                {article.topicDetail.map(
                                                  (topic, topicIndex) => (
                                                    <Link
                                                      key={topicIndex}
                                                      className="flex items-start gap-3 mb-5 practice-articles-box2-ul-li"
                                                    >
                                                      <FaAngleRight className="mt-1 practice-articles-box2-arr" />
                                                      <Link
                                                        to={`/practicedetails?gcc=${encryptUrlData(
                                                          {
                                                            topicId: topic._id,
                                                          }
                                                        )}`}
                                                        className="practice-articles-box2-text"
                                                      >
                                                        {topic?.topicName}
                                                      </Link>
                                                    </Link>
                                                  )
                                                )}
                                              </div>
                                            )}
                                        </>
                                      ) : (
                                        // 🟣 CASE 3: articleName missing → show topic directly
                                        hasTopics && (
                                          <div className="p-[1.5rem] lg:p-[2rem] !border-none practice-articles-box2-active">
                                            {article.topicDetail.map(
                                              (topic, topicIndex) => (
                                                <Link
                                                  key={topicIndex}
                                                  className="flex items-start gap-3 mb-5 practice-articles-box2-ul-li"
                                                >
                                                  <FaAngleRight className="mt-1 practice-articles-box2-arr" />
                                                  <Link
                                                    to={`/practicedetails?gcc=${encryptUrlData(
                                                      {
                                                        topicId: topic._id,
                                                      }
                                                    )}`}
                                                    className="practice-articles-box2-text"
                                                  >
                                                    {topic?.topicName}
                                                  </Link>
                                                </Link>
                                              )
                                            )}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          )}
                        </div>
                      ) : (
                        /* 🟠 CASE 2: categoryName missing → show article/topic list directly */
                        <div className="w-full">
                          {chapter.articlesDetail.map(
                            (article, articleIndex) => {
                              const globalArticleIndex = `${globalChapterIndex}-${articleIndex}`;
                              const hasArticle = !!article?.articleName?.trim();
                              const hasTopics =
                                Array.isArray(article?.topicDetail) &&
                                article.topicDetail.length > 0;

                              return (
                                <div
                                  key={globalArticleIndex}
                                  className="pb-[1.5rem]"
                                >
                                  {hasArticle ? (
                                    <>
                                      <button
                                        onClick={() =>
                                          toggleChildAccordion(
                                            globalChapterIndex,
                                            articleIndex
                                          )
                                        }
                                        className="p-[1.5rem] lg:p-[2rem] flex w-full text-start justify-between practice-articles-box2"
                                      >
                                        <span>{article?.articleName}</span>
                                        {isChildOpen(
                                          globalChapterIndex,
                                          articleIndex
                                        ) ? (
                                          <BiMinus className="practice-articles-plus" />
                                        ) : (
                                          <BsPlusLg className="practice-articles-plus" />
                                        )}
                                      </button>

                                      {isChildOpen(
                                        globalChapterIndex,
                                        articleIndex
                                      ) &&
                                        hasTopics && (
                                          <div className="p-[1.5rem] lg:p-[2rem] practice-articles-box2-active">
                                            {article.topicDetail.map(
                                              (topic, topicIndex) => (
                                                <Link
                                                  key={`${globalArticleIndex}-${topicIndex}`}
                                                  className="flex items-start gap-3 mb-5 practice-articles-box2-ul-li"
                                                >
                                                  <FaAngleRight className="mt-1 practice-articles-box2-arr" />
                                                  <Link
                                                    to={`/practicedetails?gcc=${encryptUrlData(
                                                      {
                                                        topicId: topic._id,
                                                      }
                                                    )}`}
                                                    className="practice-articles-box2-text"
                                                  >
                                                    {topic?.topicName}
                                                  </Link>
                                                </Link>
                                              )
                                            )}
                                          </div>
                                        )}
                                    </>
                                  ) : (
                                    // 🟣 CASE 3: no articleName → show topic details directly
                                    hasTopics && (
                                      <div className="w-full">
                                        {article.topicDetail.map(
                                          (topic, topicIndex) => (
                                            <div
                                              key={`${globalArticleIndex}-${topicIndex}`}
                                              className=""
                                            >
                                              {topic?.topicDetail && (
                                                <div className="w-full">
                                                  {topic?.isPrintable && (
                                                    <div className="w-full flex justify-end mb-5">
                                                      <button
                                                        onClick={() =>
                                                          handlePrint(
                                                            printRef,
                                                            topic?.topicName
                                                          )
                                                        }
                                                        className="w-max px-[2rem] py-[.5rem] btn-print"
                                                      >
                                                        Print
                                                      </button>
                                                    </div>
                                                  )}
                                                  <div className="w-full">
                                                    <h1 className="mb-5 practice-topic-title">
                                                      {topic?.topicName}
                                                    </h1>
                                                    <div
                                                      ref={printRef}
                                                      className="break-words practice-desc"
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          DOMPurify.sanitize(
                                                            topic?.topicDetail
                                                          ) || "",
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    )
                                  )}
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            {practiceList?.length === 0 && (
              <h1 className="w-full text-center no-found">No Data found</h1>
            )}
            {totalItems > 10 && (
              <div
                data-aos="zoom-in"
                data-aos-once="true"
                className="flex items-center justify-center text-center my-2"
              >
                <button
                  className="flex items-center bg-[#c99930] text-white mx-1 px-[1rem] py-1 rounded disabled:opacity-50"
                  onClick={() => setOffset(0)}
                  disabled={currentPage === 1}
                >
                  <span className="text-[1.8rem] mb-1">&laquo;</span>
                </button>
                <button
                  className="flex items-center bg-[#c99930] text-white mx-1 px-[1.2rem] py-1 rounded disabled:opacity-50"
                  onClick={() => setOffset(offset - limit)}
                  disabled={currentPage === 1}
                >
                  <span className="text-[1.8rem] mb-1">&lsaquo;</span>
                </button>
                <span className="mx-2 font-bold text-[#c99930] text-[1.8rem]">
                  Page {currentPage} of {totalPages || 1}
                </span>
                <button
                  className="flex items-center bg-[#c99930] text-white mx-1 px-[1.2rem] py-1 rounded disabled:opacity-50"
                  onClick={() => setOffset(offset + limit)}
                  disabled={currentPage === totalPages}
                >
                  <span className="text-[1.8rem] mb-1">&rsaquo;</span>
                </button>
                <button
                  className="flex items-center bg-[#c99930] text-white mx-1 px-[1rem] py-1 rounded disabled:opacity-50"
                  onClick={() => setOffset((totalPages - 1) * limit)}
                  disabled={currentPage === totalPages}
                >
                  <span className="text-[1.8rem] mb-1">&raquo;</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PracticeArticle;
